/**
 * Internal dependencies
 */
import { WMUToggleClass } from ".";

/**
 * 
 */
class WMUToggleGroup extends EventTarget {

	/**
	 * 
	 */
	constructor( args = {} )
	{
		super();

		this.args = {
			alwaysOneToggleOn: false,
			disableToggleLink: false,
			groupElement: null,
			onlyOneToggleOn: true,
			toggleSelector: '',
			toggleArgs: {
				autoInit: false,
			},
			ignoreHtmlAttributes: false,
			autoInit: true,
			initIndex: -1,
			...args
		};

		this.alwaysOneToggleOn = this.args.alwaysOneToggleOn;
		this.disableToggleLink = this.args.disableToggleLink;
		this.groupElement = this.args.groupElement;
		this.onlyOneToggleOn = this.args.onlyOneToggleOn;
		this.toggleSelector = this.args.toggleSelector;
		this.toggleArgs = this.args.toggleArgs;
		this.toggleList = [];
		this.toggleElementList = [];
		this.isInit = false;

		if ( this.groupElement )
		{
			this.groupElement.wmuToggleGroup = this;
		}

		if ( this.toggleArgs && undefined === this.toggleArgs.disableInnerLink )
		{
			this.toggleArgs.disableInnerLink = this.disableToggleLink;
		}

		if ( true === this.args.autoInit )
		{
			this.init();
		}
	}

	/**
	 * 
	 */
	init()
	{
		this.onSetStatus = this.onSetStatus.bind( this );
		this.onToggleOff = this.onToggleOff.bind( this );
		this.onToggleOn = this.onToggleOn.bind( this );

		if ( false === this.args.ignoreHtmlAttributes )
		{
			this.readAttributeArgs();
		}

		const toggleSelector = this.getArg( 'toggleSelector' );

		if ( toggleSelector )
		{
			this.getGroupElement().querySelectorAll( toggleSelector ).forEach( ( element ) => this.addToggle( element ) );
		}
		else
		{
			console.warn( 'You must set an attribute data-toggle-selector on your toggle class group element.', this.getGroupElement() );
		}
		
		this.isInit = true;

		document.dispatchEvent( new CustomEvent( 'wmuToggleGroupInit', { detail: {
			wmuToggleGroup: this,
			element: this.groupElement,
		} } ) );

		const initIndex = this.getArg( 'initIndex');

		if ( initIndex > -1 && initIndex < this.toggleElementList.length - 1 )
		{
			this.toggleList[ initIndex ].setStatus( 'on' );
		}
	}

	/**
	 * 
	 */
	clear()
	{
		this.toggleList.forEach( ( toggle ) =>
		{
			toggle.clear();
		} );

		this.toggleList = null;
		this.toggleElementList = null;
		this.groupElement.wmuToggleGroup = null;
	}

	/**
	 * 
	 */
	getGroupElement()
	{
		return ( this.groupElement ) ? this.groupElement : document;
	}

	/**
	 * 
	 */
	addToggle( element )
	{
		if ( -1 === this.toggleElementList.indexOf( element ) )
		{
			const toggle = new WMUToggleClass( element, this.getArg( 'toggleArgs' ) );
			toggle.addEventListener( 'setStatus', this.onSetStatus );
			toggle.addEventListener( 'toggleOff', this.onToggleOff );
			toggle.addEventListener( 'toggleOn', this.onToggleOn );
			this.toggleList.push( toggle );
			this.toggleElementList.push( element );
			toggle.init();
		}
	}

	/**
	 * 
	 */
	readAttributeArgs()
	{
		const toggleArgs = {};
		let value;

		if ( value = this.groupElement.getAttribute( 'data-toggle-target-selector' ) )
		{
			toggleArgs.targetSelector = value;
		}

		if ( value = this.groupElement.getAttribute( 'data-toggle-fx' ) )
		{
			toggleArgs.fx = value;
		}

		if ( value = this.groupElement.getAttribute( 'data-toggle-fx-target-selector' ) )
		{
			toggleArgs.fxTargetSelector = value;
		}

		const initIndex = this.groupElement.getAttribute( 'data-toggle-init-index' );

		this.attributeArgs = {
			toggleSelector: this.groupElement.getAttribute( 'data-toggle-selector' ) || undefined,
			onlyOneToggleOn: this.readBooleanAttribute( this.groupElement, 'data-only-one-toggle-on' ),
			toggleArgs: toggleArgs,
			initIndex: ( initIndex !== null && initIndex !== '' ) ? parseInt( initIndex ) : undefined,
		};
	}

	/**
	 * 
	 */
	readBooleanAttribute( element, attributeName )
	{
		const attributeValue = element.getAttribute( attributeName );

		if ( null === attributeValue )
		{
			return undefined;
		}
		
		return ( '' === attributeValue || 'false' === attributeValue || '0' === attributeValue ) ? false : true;
	}

	/**
	 * 
	 */
	getArg( key )
	{
		if ( true === this.args.ignoreHtmlAttributes || ! this.attributeArgs ||  undefined === this.attributeArgs[ key ] )
		{
			return this.args[ key ];
		}

		if ( 'toggleArgs' === key && this.attributeArgs && this.attributeArgs.toggleArgs )
		{
			return {
				...this.toggleArgs,
				...this.attributeArgs.toggleArgs,
			};
		}

		return ( this.attributeArgs ) ? this.attributeArgs[ key ] : undefined;
	}

	/**
	 * 
	 */
	onSetStatus( event )
	{
		this.dispatchEvent( new CustomEvent( 'setStatus', { detail: {
			...event.detail,
			toggleGroup: this
		} } ) );
	}

	/**
	 * 
	 */
	onToggleOn( event )
	{
		this.dispatchEvent( new CustomEvent( 'toggleOn', { detail: {
			...event.detail,
			toggleGroup: this
		} } ) );

		if ( this.getArg( 'onlyOneToggleOn' ) )
		{
			this.toggleOffOthers( event.detail.toggle );
		}

		/**
		 * Ici si alwaysOneToggleOn on désactive le toggle
		 * Ah attention il faut que ce soit une désactivation input user only
		 */
		if ( this.getArg( 'alwaysOneToggleOn') )
		{
			event.detail.toggle.args.enableUserInput = false;
		}
	}

	/**
	 * 
	 */
	onToggleOff( event )
	{
		this.dispatchEvent( new CustomEvent( 'toggleOff', { detail: {
			...event.detail,
			toggleGroup: this
		} } ) );

		/**
		 * Ici si alwaysOneToggleOn on réactive le toggle
		 */
		if ( this.getArg( 'alwaysOneToggleOn') )
		{
			event.detail.toggle.args.enableUserInput = true;
		}
	}

	/**
	 * 
	 */
	toggleOffOthers( toggleKept )
	{
		this.toggleList.forEach( ( toggle ) =>
		{
			if ( toggle !== toggleKept )
			{
				toggle.setStatus( 'off' );
			}
		} );
	}

}

export default WMUToggleGroup;
